module.exports = __webpack_public_path__ + "static/media/datepicker.a48161e4.less";